import {Component, OnDestroy, OnInit, Input} from '@angular/core';
import {ProjectConstants} from '../../../project-constants';
import {FormBuilder, FormGroup, NgForm, Validators} from '@angular/forms';
import {Subscription} from 'rxjs';
import {ActivatedRoute, Router} from '@angular/router';
import * as toastr from 'toastr';
import {CurrencyModel} from '../../../../models/CurrencyModel';
import {CurrencyService} from '../../../general-services/service-currency-anagraf/currency.service';
import {ContractTypeModel} from '../../../../models/ContractTypeModel';

@Component({
  selector: 'app-edit-currency-anagraf',
  templateUrl: './edit-currency-anagraf.component.html',
  styleUrls: ['./edit-currency-anagraf.component.scss']
})
export class EditCurrencyAnagrafComponent extends ProjectConstants implements OnInit, OnDestroy {

  currency: CurrencyModel;
  formValidator: FormGroup;
  formBuilder: FormBuilder;

  saveSubscribe: Subscription;
  parameterSubscribe: Subscription;
  submitted: boolean;

  id: number;
  currencyCod: string;
  currencyTypeJson: any;
  description: any;


  constructor(private route: ActivatedRoute, private router: Router,
    private currencyService: CurrencyService, private _Activatedroute: ActivatedRoute) {
    super();

    this.parameterSubscribe = this.route
      .queryParams
      .subscribe(params => {
        this.currencyTypeJson = params['row'];
      });

    this.currency = new CurrencyModel();

    this.formBuilder = new FormBuilder();

    this.formValidator = this.formBuilder.group({
      cod: [{value: '', disabled: false}, Validators.required],
      description: [{value: '', disabled: false}, Validators.required]
    });

    this.currency = JSON.parse(this.currencyTypeJson) as CurrencyModel;

    this.formValidator.patchValue({
      cod: this.currency ? this.currency.cod : ''
    });

    this.formValidator.patchValue({
      description: this.currency ? this.currency.description : ''
    });

    _Activatedroute.params.subscribe(params => {
      this.id = params['id'];
      this.currencyCod = params['cod'];
      this.description = params['description'];
    });
  }

  ngOnInit() {
  }

  cancel(event: any) {
    event.preventDefault();
    this.router.navigate([this.LINKS.MASTER_DATA + this.LINKS.ANAGRAPH.CURRENCY_ANAGRF]);
  }

  edit() {
    this.submitted = true;
    if (this.formValidator.valid) {
      this.currency.cod = this.formValidator.controls['cod'].value;
      this.currency.description = this.formValidator.controls['description'].value;
      this.saveSubscribe = this.currencyService.update(this.currencyService.baseUrl, this.currency).subscribe(
        (result: any) => {
          if (result === -1) {
            toastr.options.timeout = 5000;
            toastr.warning('Duplicate item, Currency Cod already exists', 'Warning');
          } else if (result === -2) {
            toastr.options.timeout = 5000;
            toastr.warning('Element already used', 'Warning');
          }else {
            toastr.success('Currency with id ' + this.id + ' was added with success', 'Success');
            this.router.navigate([this.LINKS.MASTER_DATA + this.LINKS.ANAGRAPH.CURRENCY_ANAGRF]);
          }
        }, error => {
          toastr.error('Element has not edited', 'Error');
        });
    }
  }

  ngOnDestroy(): void {
    if (this.saveSubscribe) {
    this.saveSubscribe.unsubscribe();
  }
}

}
